// Estado compartido del módulo (sin tocar el store global).
import Vue from "vue";
import service from "@/pages/institucional/institucionalService";

export const HINT_KEY = "inst_hint";

export const state = Vue.observable({
  status: "idle", // idle | loading | ok | anon | off | no_access | error
  me: null,
});

function setHint(on) {
  try {
    if (on) localStorage.setItem(HINT_KEY, "1");
    else localStorage.removeItem(HINT_KEY);
  } catch (e) {
    // almacenamiento bloqueado: el menú simplemente no se muestra
  }
}

export function loadMe() {
  let token = null;
  try {
    token = localStorage.getItem("token");
  } catch (e) {
    token = null;
  }
  if (!token) {
    state.status = "anon";
    return Promise.resolve(state);
  }
  state.status = "loading";
  return service
    .me()
    .then((r) => {
      if (r.status === 200) {
        state.me = r.data;
        state.status = "ok";
        setHint(true);
      } else if (r.status === 404) {
        state.status = "off";
      } else if (r.status === 401) {
        state.status = "anon";
      } else {
        state.status = "no_access";
        setHint(false);
      }
      return state;
    })
    .catch(() => {
      state.status = "error";
      return state;
    });
}
